module.exports = __webpack_public_path__ + "static/media/item_22_5_comp.8e0c2eac.png";